document.addEventListener('DOMContentLoaded', function() {
  //console.log("Script started.");
  
  // Function to clone the button and append it
  function cloneCustomilyButton() {
    //console.log("cloneCustomilyButton called.");
  
    // Remove the existing cloned button if it exists
    var existingClonedButton = document.getElementById('customily-cart-btn-cloned');
    if (existingClonedButton) {
      //console.log("Existing cloned button found, removing it.");
      existingClonedButton.remove();
    }
  
    // Select the original button inside the modal
    var originalButton = document.getElementById('customily-cart-btn');
    if (originalButton) {
      //console.log("Original button found:", originalButton);
  
      // Clone the button
      var clonedButton = originalButton.cloneNode(true);
      // Assign a new ID to the cloned button
      clonedButton.id = 'customily-cart-btn-cloned';
  
      // Remove any inline styles from the cloned button
      clonedButton.style = '';
  
      // Style the cloned button to center it
      clonedButton.style.display = 'block';
      clonedButton.style.margin = '5px auto'; // Add some margin and center it
      clonedButton.style.width = '60%'; // Adjust width as needed
  
      // Determine the wrapper element based on viewport width
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      var wrapperSelector;
  
      if (viewportWidth >= 768) {
        // Tablet and desktop view
        wrapperSelector = '.cl-preview-wrapper';
      } else {
        // Mobile view
        wrapperSelector = '.canvas-wrapper';
      }
  
      // Select the wrapper element
      var wrapperElement = document.querySelector(wrapperSelector);
      if (wrapperElement) {
        //console.log(wrapperSelector + " found:", wrapperElement);
  
        // Append the cloned button under the wrapper
        wrapperElement.parentNode.insertBefore(clonedButton, wrapperElement.nextSibling);  
        //console.log("Cloned button appended under " + wrapperSelector + ":", clonedButton);
        
      } else {
        //console.log(wrapperSelector + " not found.");
      }
  
      // Add click event to simulate click on the original button
      clonedButton.addEventListener('click', function() {
        //console.log("Cloned button clicked. Simulating click on original button.");
        
        // Scroll to the original button position
        originalButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
  
        // Simulate a click on the original button
        originalButton.click();
  
        // Close the modal by simulating a click on the close button
        var closeButton = document.querySelector('.customily-close-button');
        if (closeButton) {
          //console.log("Close button found. Closing the modal.");
          closeButton.click(); // Simulate click on the close button to close the modal
        } else {
          //console.log("Close button not found. Hiding the modal manually.");
          // As a fallback, hide the modal manually if the close button isn't found
          var modalElement = document.querySelector('.customily-modal-preview-only');
          if (modalElement) {
            modalElement.style.display = 'none'; // Hide the modal
          }
        }
      });
    } else {
      //console.log("Original button not found.");
    }
  }
  
  // Function to remove the cloned button when the modal is closed
  function removeClonedButton() {
    //console.log("removeClonedButton called.");
    var existingClonedButton = document.getElementById('customily-cart-btn-cloned');
    if (existingClonedButton) {
      //console.log("Existing cloned button found, removing it.");
      existingClonedButton.remove();
    } else {
      //console.log("No cloned button found to remove.");
    }
  }
  
  // Function to observe changes to the modal's visibility
  function observeModalVisibility(modalElement) {
    //console.log("observeModalVisibility called.");
  
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          var display = window.getComputedStyle(modalElement).display;
          //console.log("Modal display style changed to:", display);
  
          if (display !== 'none') {
            //console.log("Modal is now visible.");
            setTimeout(cloneCustomilyButton, 5);
          } else {
            //console.log("Modal is now hidden.");
            removeClonedButton();
          }
        }
      });
    });
  
    // Start observing the modal element for attribute changes
    observer.observe(modalElement, { attributes: true });
    //console.log("MutationObserver started on modal element.");
  }
  
  // Wait for the modal element to be available in the DOM
  function waitForModalElement() {
    var modalElement = document.querySelector('.customily-modal-preview-only');
    if (modalElement) {
      //console.log("Modal element found:", modalElement);
      observeModalVisibility(modalElement);
    } else {
      //console.log("Modal element not found. Retrying in 500ms...");
      setTimeout(waitForModalElement, 500);
    }
  }
  
  // Start the process
  waitForModalElement();
  
  // Update the button placement on window resize
  window.addEventListener('resize', function() {
    // If the modal is open, update the button placement
    var modalElement = document.querySelector('.customily-modal-preview-only');
    if (modalElement && window.getComputedStyle(modalElement).display !== 'none') {
      //console.log("Window resized. Updating button placement.");
      cloneCustomilyButton();
    }
  });

  //====== Handle Meta Filter Photo Upload ===
function handleMetaFilterUpload (){  
  const productForms = document.querySelectorAll('.product-form');
  let specialFilterAvailable = false;
  
  productForms.forEach(form => {
    if ((form.textContent.includes("Special Filter")) || (form.textContent.includes("Quick Filter"))) {
      specialFilterAvailable = true;
    }
  });

// console.log('specialFilterAvailable')
  // 1) Helper to toggle cart button + spinner
  // Updated helper to toggle loading state on all three buttons
  function setCartLoading(isLoading) {
    ['customily-cart-btn', 'customily-preview-button', 'sticky-customily-preview-button']
      .forEach(id => {
        const btn = document.getElementById(id);
        if (!btn) return;
        btn.disabled = isLoading;
        const spinner = btn.querySelector('.ld');
        if (spinner) spinner.style.display = isLoading ? 'block' : 'none';
      });
  }
  
  
  
  // === Detection control flag ===
  let detectionEnabled = false;
  let hasUpload = false;

  // === Enable detection on button click ===  
  function detectPhotoButtonClick() {
    const selector = '#customily-download-button, .customily-download-button';
    document.querySelectorAll(selector).forEach(btn => {
      const activateDetection = e => {
        // Prevent duplicate execution
        if (!detectionEnabled) {
          console.log('Download button tapped/clicked — starting detection.');
          detectionEnabled = true;
        }
      };
      btn.addEventListener('pointerdown', activateDetection);
      // Optional: fallback for old browsers
      btn.addEventListener('touchstart', activateDetection, { passive: true });
      btn.addEventListener('click', activateDetection);
    });
  }
  detectPhotoButtonClick();
  
  // === Intercept XHR for upload/result ===
  (() => {
    const origOpen = XMLHttpRequest.prototype.open;
    const origSend = XMLHttpRequest.prototype.send;
  
    XMLHttpRequest.prototype.open = function(method, url, ...args) {
      this._url = url;
      return origOpen.call(this, method, url, ...args);
    };
  
    XMLHttpRequest.prototype.send = function(body) {
      if (detectionEnabled && this._url && this._url.startsWith('data:image/png;base64')) {
        // console.log('3 Photo upload XHR detected:', this._url);
        hasUpload = true;
        setCartLoading(true);  
        if  (!specialFilterAvailable){
          setTimeout(() => {
            hasUpload = false;
            setCartLoading(false);  
            detectionEnabled = false;
            detectPhotoButtonClick();                      
          }, 10000); //
        }
      }
  
      this.addEventListener('readystatechange', () => {
        if (
            detectionEnabled &&
            this.readyState === 4 &&
            hasUpload &&
            this.responseURL.includes('customily') &&
            this.responseURL.includes('js-lib-temp-images') &&
            this.responseURL.endsWith('.webp')
        ) {
          // console.log('4 Processed photo XHR returned:', this.responseURL);
          hasUpload = false;
          setCartLoading(false);  
          detectionEnabled = false;
          detectPhotoButtonClick();                  
        }
      });
  
      return origSend.call(this, body);
    };
  })();
  
  // === Intercept IMG.src and setAttribute ===
  (() => {
    // Override setAttribute
    const origSetAttr = Element.prototype.setAttribute;
    Element.prototype.setAttribute = function(name, value) {
      if (
            detectionEnabled &&
            hasUpload &&
            this.tagName === 'IMG' &&
            name === 'src' &&
            value.includes('customily') &&
            value.includes('js-lib-temp-images')
      ) {
        // console.log('5 Processed photo IMG src set:', value);
        hasUpload = false;
        setCartLoading(false);  
        detectionEnabled = false;
        detectPhotoButtonClick();                
      }
      return origSetAttr.call(this, name, value);
    };
  
    // Override the `src` property setter
    const desc = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
    Object.defineProperty(HTMLImageElement.prototype, 'src', {
      set(val) {
        if (
            detectionEnabled &&
            hasUpload &&
            val.includes('customily') &&
            val.includes('js-lib-temp-images')
        ) {
          // console.log('6 Processed photo assigned to img.src:', val);
          hasUpload = false;
          setCartLoading(false);
          detectionEnabled = false;
          detectPhotoButtonClick();                  
        }
        return desc.set.call(this, val);
      },
      get() {
        return desc.get.call(this);
      },
      configurable: true,
      enumerable: true
    });
  })();
  

};
  
setTimeout(() => {
    handleMetaFilterUpload(); 
}, 2000); //

//======    

});
